import React from "react";
import { useLoaderData } from "react-router-dom";

import ReportParametersSelector from "../../components/ReportParametersSelector";

function Report() {
  const data = useLoaderData();

  return (
    <div className="flex-grow-1 p-4 overflow-auto">
      <ReportParametersSelector data={data} />
    </div>
  );
}

export default Report;
